var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1846 19.6616C21.6051 20.0821 21.6051 20.764 21.1846 21.1846C20.764 21.6051 20.0821 21.6051 19.6616 21.1846L15.8923 17.4153C15.4718 16.9948 15.4718 16.3129 15.8923 15.8923C16.3129 15.4718 16.9948 15.4718 17.4153 15.8923L21.1846 19.6616ZM9.11539 17.7308C4.35724 17.7308 0.5 13.8735 0.5 9.11539C0.5 4.35724 4.35724 0.5 9.11539 0.5C13.8735 0.5 17.7308 4.35724 17.7308 9.11539C17.7308 13.8735 13.8735 17.7308 9.11539 17.7308ZM9.11539 15.5769C12.684 15.5769 15.5769 12.684 15.5769 9.11539C15.5769 5.54678 12.684 2.65385 9.11539 2.65385C5.54678 2.65385 2.65385 5.54678 2.65385 9.11539C2.65385 12.684 5.54678 15.5769 9.11539 15.5769Z",
    fill: "#979EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cf0f7a5dd8ef2a824ed909e519f87164.svg";
export { ForwardRef as ReactComponent };